module.exports = __webpack_public_path__ + "img/01.2f5503e6.jpg";